<template>
  <custom-dialog
    width="800px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    class="select-device-type-dialog"
  >
    <div class="dialog-body">
      <div class="types">
        <div
          class="type-item"
          :class="{active: item.value === type}"
          @click="onSelectType(item.value)"
          v-for="(item,index) in typeData"
          :key="index"
        >
          <div class="label">{{item.label}}</div>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{ $t('Common.com_confirm') }}</el-button>
      <add-case-dialog
        v-if="addCaseVisible"
        @close="addCaseVisible = false"
        :model="addCaseModel"
        @success="onAddCaseSuccess"
        :serviceClassVisible="false"
        :createModeVisible="false"
      ></add-case-dialog>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import addCaseDialog from '@/pages/asm/components/add_case_dialog';

export default {
  mixins: [dialogMixins],
  components: {
    addCaseDialog
  },
  data() {
    return {
      // maintain - 维修  upkeep - 保养  rework - 返工
      type: '',

      addCaseVisible: false,
      addCaseModel: {},
    };
  },
  computed: {
    typeData() {
      return [
        {
          label: this.$t('asm_select_service_type_dialog.wei_xiu'),
          value: 'maintain'
        },
        {
          label: this.$t('asm_select_service_type_dialog.bao_yang'),
          value: 'upkeep'
        },
        {
          label: this.$t('asm_select_service_type_dialog.fan_gong'),
          value: 'rework'
        },
      ];
    }
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    /**
     * 如果type是维修，则进入 add_case_dialog中进行表单提交
     * 如果type是保养，返修，则直接提交接口
     */
    onConfirm() {
      if (this.type === 'maintain') {
        this.addCaseModel = {
          type: 'checkbox',
          title: this.$t('asm_select_service_type_dialog.tian_jia_an_li'),
          data: this.model.data,
          createMode: '3', // 选择机器
        };
        this.addCaseVisible = true;
      } else {
        if (this.type === 'upkeep') {
          this.selectUpkeep();
        } else {
          this.selectRework();
        }
      }

    },

    /**
     * 判断工单是否存在的resolve data
     * @typedef {Object} OrderExitResolveData
     * @property {Boolean} isExit - 工单是否存在
     * @property {String} workOrderId - workOrderId
     */

    /**
     * 判断工单是否存在
     * @param {Number} workOrderType 工单类型： 保养工单 - 20； 返工工单 - 50
     * @return {Promise<OrderExitResolveData>} Promise result
     */
    async checkOrderIsExit(workOrderType) {
      // // mock
      // if (this.isDev) {
      //   return {
      //     isExit: false,
      //     workOrderId: '',
      //   };
      // }
      const bodyNum = this.model.data.bodyNum;
      const reqData = {
        bodyNum, workOrderType
      };
      const res = await this.$getJSON(apis.WorkOrderUnfinished, reqData);
      const resolveData = {
        isExit: false,
        workOrderId: '',
      };
      if (res.data && res.data.workOrderId) {
        resolveData.isExit = true;
        resolveData.workOrderId = res.data.workOrderId;
      }

      return resolveData;
    },


    // 一键生成case工单生成【默认保养】
    async createOrder(caseOrderType) {
      const reqData = {
        bodyNum: this.model.data.bodyNum,
        caseOrderType
      };
      if (this.model.data.machineVersion) {
        reqData.itemVersion = this.model.data.machineVersion;
      }

      // 获取这个设备下，最大的返修版本号
      const res = await this.$getJSON(apis.BasicItemGroupMaxItemVersion, {
        // productCode: this.model.data.productCode,
        productSn: this.model.data.productSn,
      });

      if (res.data) {
        reqData.caseOrderDesc = res.data;
      }

      return this.$postJSON(apis.caseOrderSave4Simple, reqData, true);
    },

    // 选择 - 保养
    async selectUpkeep() {

      const workOrderType = 20; // 工单类型， 20 - 保养

      // 判断工单是否存在
      const res = await this.checkOrderIsExit(workOrderType);

      // 如果存在，则提示
      if (res.isExit) {
        this.$message({
          message: this.$t('asm_select_service_type_dialog.bygdycz'),
          type: 'error',
        });
      } else {
        const bodyNum = this.model.data.bodyNum;

        // 如果工单不存在，则弹出提示信息：“此机器【601010109846】暂无保养工单，是否立即创建一个？”点击【立即生成】则创建一个保养案例
        const subStr = `【${bodyNum}】`;
        const tips = this.$t('asm_select_service_type_dialog.cjqozwbygdsfljcjyg', [subStr]);
        await this.$showConfirm(tips, {
          confirmButtonText: this.$t('asm_select_service_type_dialog.li_ji_sheng_cheng'),
          cancelButtonText: this.$t('Common.com_cancel'),
          closeOnClickModal: false,
          type: 'warning',
        });

        // 创建保养工单
        await this.createOrder(workOrderType);

        // close this dialog
        this.closeDialog();

        this.$emit('success');
      }

    },

    // 选择 - 返修
    async selectRework() {
      const workOrderType = 50; // 工单类型， 50 - 返工

      // 判断工单是否存在
      const res = await this.checkOrderIsExit(workOrderType);

      // 如果存在，则提示
      if (res.isExit) {
        this.$message({
          message: this.$t('asm_select_service_type_dialog.fggdycz'),
          type: 'error',
        });
      } else {
        const bodyNum = this.model.data.bodyNum;

        const maxVersionTips = this.$t('asm_select_service_type_dialog.ydzxfgbbwxfg');

        // 获取这个设备下，最大的返修版本号
        const result = await this.$getJSON(apis.BasicItemGroupMaxItemVersion, {
          productSn: this.model.data.productSn,
        });

        // 如果是返工工单，还要加一个判断，如果接口没有返回值，也不能创建工单
        if (!result.data) {
          this.$message({
            message: `[${bodyNum}]${maxVersionTips}`,
            type: 'error',
          });
          return;
        }

        // 如果返回了最大版本号，还要判断最大版本号是否大于当前所选设备的版本号
        if (result.data <= this.model.data.machineVersion) {
          this.$message({
            message: `[${bodyNum}]${maxVersionTips}`,
            type: 'error',
          });
          return;
        }

        // 如果工单不存在，则弹出提示信息：“确定要为【60401000144】创建返工单吗？”
        const tips = this.$t('asm_select_service_type_dialog.qdywocjofggdm', [bodyNum,result.data]);
        await this.$showConfirm(tips);

        // 创建返工工单
        await this.createOrder(workOrderType);

        // close this dialog
        this.closeDialog();

        this.$emit('success');
      }

    },

    onSelectType(type) {
      this.type = type;
    },

    onAddCaseSuccess() {
      this.$emit('success');
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.select-device-type-dialog {
  .types {
    display: flex;
    margin-left: -8px;
    margin-right: -8px;

    .type-item {
      flex: 1;
      background-color: #f8f9fb;
      height: 70px;
      position: relative;
      cursor: pointer;
      margin: 0 8px;

      &.active {
        &::before {
          border: 2px solid #0d9ae0;
          background: rgba(13, 154, 224, 0.1);
        }
      }

      &::before {
        content: ' ';
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border: 1px solid #e4ebf2;
      }

      .label {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        line-height: 70px;
        color: #495057;
      }
    }

    .space {
      margin-left: 16px;
      margin-right: 16px;
    }
  }
}
</style>
